<template>
<div class="chapter">
<div class="inner_page">
<p class="ahead"><a id="page_ii"><strong>R<span class="small">ECONSTRUCTING</span> A<span class="small">MERICA</span></strong></a></p><a id="page_ii">
<p class="editor">Andrew L. Slap, series editor</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// seriestitle.vue?6c00bd04